var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      ref: "mslQRCodeDialog",
      attrs: {
        width: "350px",
        visible: _vm.dialogVisible,
        scrollbar: false,
        modal: false,
        "append-to-body": true,
        "custom-class": "msl-qrcode-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onClose,
        closed: _vm.onClosed,
        open: _vm.onOpen,
        opened: _vm.onOpened,
      },
    },
    [
      _c(
        "div",
        { staticClass: "qrcode" },
        [
          _c("h3", { staticStyle: { "text-align": "center" } }, [
            _vm._v("Open WeChat to scan the qrcode "),
            _c("br"),
            _vm._v("and bind with the account"),
          ]),
          _c(
            "el-image",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { src: _vm.qrcodeUrl },
              on: { load: _vm.imageLoad },
            },
            [
              _c(
                "div",
                {
                  staticClass: "image-slot",
                  attrs: { slot: "error" },
                  slot: "error",
                },
                [_c("i", { staticClass: "el-icon-picture-outline" })]
              ),
            ]
          ),
          _c("p", [_vm._v(_vm._s(_vm.userInfo.name))]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }